module.exports = __webpack_public_path__ + "static/img/ext1.6ec58c2a.jpg";